import { push, ref } from "firebase/database";
import { db } from "../firebaseConfig";
import {
  listPendingAlerts,
  removePendingAlert,
} from "./alertsQueue";
import { uploadImageToServer } from "./uploadToServer";

let syncInFlight = false;
let onlineHandlerAttached = false;

export async function flushPendingAlertsQueue() {
  if (syncInFlight) return;
  if (typeof navigator !== "undefined" && navigator.onLine === false) return;
  syncInFlight = true;
  try {
    const pending = await listPendingAlerts();
    if (!Array.isArray(pending) || !pending.length) return;

    for (const entry of pending) {
      try {
        const payload = { ...(entry?.payload || {}) };
        const category = String(payload?.category || "").trim();
        if (!category) {
          await removePendingAlert(entry?.id);
          continue;
        }

        if (!payload.imageUrl && entry?.imageFile) {
          const uploaded = await uploadImageToServer(entry.imageFile);
          payload.imageUrl = uploaded;
        }

        await push(ref(db, `alerts/${category}`), payload);
        await removePendingAlert(entry?.id);
      } catch (err) {
        console.warn("Falha ao sincronizar alerta pendente:", err);
      }
    }
  } finally {
    syncInFlight = false;
  }
}

export function startAlertsAutoSync() {
  flushPendingAlertsQueue();
  if (onlineHandlerAttached || typeof window === "undefined") return;
  const onOnline = () => {
    flushPendingAlertsQueue();
  };
  window.addEventListener("online", onOnline);
  onlineHandlerAttached = true;
}

